/**
 * A list of error properties we want to enrich our error record with.
 * @type {String[]}
 */
export const FIELDS = [
    'message',
    'stack',

    // inherited (not own property)
    'name',

    // optional
    'code',
    'details',
    'level',

    // non standard error getters for file name
    'file',
    'filename',
    'fileName',
    'line',
    'lineno',
    'lineNumber',
    'column',
    'colno',
    'columnNumber'
];
